import React, { useState } from "react";
import { Box, Flex, Span } from "../../assets/ui";
import { LogoMobileIcon } from "../../assets/icons";
import { Field } from "../common/FormElements";
import { StyledButton } from "../common/Button";
import moment from "moment";

const EnterKeyModal = ({ setActiveModal, checkKey }) => {
  const [enteredKey, setKey] = useState("");
  const [enteredKeyError, setKeyError] = useState("");
  const checkKeyRequest = async e => {
    const res = await checkKey(enteredKey);
    if (res && res.success) {
      const localStorage = window.localStorage;
      const keyWithDate = {
        key: enteredKey,
        expirationDate: moment()
          .utc()
          .add(1, "hour")
          .valueOf()
      };
      localStorage.setItem("accessKey", JSON.stringify(keyWithDate));
    } else {
      res && setKeyError(res.message);
    }
    return null;
  };

  const submitKey = e => {
    e.preventDefault();

    checkKeyRequest();
  };

  const onChangeHandler = e => {
    setKey(e.target.value);
    enteredKeyError && setKeyError("");
  };

  return (
    <Box
      background="white"
      borderRadius="8px"
      padding="24px"
      pb={["38px", "64px"]}
      width={["90vw", "464px"]}
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
        mb={["50px", "74px"]}
      >
        <LogoMobileIcon />
      </Flex>
      <Box
        textAlign="center"
        fontWeight="bold"
        fontSize="22px"
        lineHeight="32px"
        mb="32px"
        color="#233247"
      >
        Enter access key
      </Box>
      <Box width={["100%", "320px"]} m={"0 auto"}>
        <form onSubmit={submitKey}>
          <Field
            type="text"
            value={enteredKey}
            onChange={onChangeHandler}
            placeholder={"X | X | X | X | X | X "}
            letterSpacing={"0.45rem"}
            wrapperStyle={{ m: "0 auto 4px", width: ["100%", "288px"] }}
          />
          <Box
            fontSize="14px"
            lineHeight="14px"
            color="#ED3163"
            height="14px"
            width={["100%", "288px"]}
            mx="auto"
            mb={["10px", "24px"]}
          >
            {enteredKeyError}
          </Box>
          <StyledButton type="submit" width="100%">
            SUBMIT
          </StyledButton>
        </form>
      </Box>
      <Flex
        flexDirection={["column", "row"]}
        color="#9EA0A5"
        justifyContent="center"
        alignItems="center"
        fontSize="14px"
        lineHeight="22px"
        mt={["18px", "26px"]}
        mb={["16px", "52px"]}
      >
        <Span mr={[0, "5px"]}>Don't have access key.</Span>
        <Span
          color="#ED3163"
          cursor="pointer"
          onClick={() => setActiveModal("requestKey")}
        >
          Request one now.
        </Span>
      </Flex>
      <Flex
        flexDirection="column"
        fontSize={["24px", "36px"]}
        fontWeight="600"
        color="#233247"
        lineHeight={["28px", "42px"]}
        justifyContent="center"
        alignItems="center"
      >
        <Span>The future of</Span>
        <Span>
          <Span color="#ED3163">sports</Span> is now!
        </Span>
      </Flex>
    </Box>
  );
};

export default EnterKeyModal;
